export default __webpack_public_path__ + "static/media/Hai-Ciso .8e8e5793.png";